import React            from 'react';

class Base extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return (
            <textarea 
                type            = { p.type } 
                className       = { `simprakit-textarea-input${ p.className ? ' ' + p.className : '' }`} 
                value           = { p.value || '' } 
                tabIndex        = { p.tabIndex } 
                onChange        = { p.onChange }
                onClick         = { p.onClick }
                onFocus         = { p.onFocus }
                onBlur          = { p.onBlur }
                onKeyUp         = { p.onKeyUp }
                step            = { 'any' }
                onKeyDown       = { p.onKeyDown }
                placeholder     = { p.placeholder || '' }
                ref             = 'INPUT'
                rows            = { p.rows }
                disabled        = { p.isDisabled }
                maxLength       = { p.maxLength }
                pattern         = { p.pattern }
                required        = { p.required }
                autoComplete    = 'off'
                max             = { p.max }
                min             = { p.min }
                { ...p.attrs }
            />
        )
    }
}

export default Base;